import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GungCommonModule } from 'gung-common';
import { GungStandardModule } from '../../gung-standard.module';
import { AiChatComponent } from './components/ai-chat/ai-chat.component';
import { GlippyChartComponent } from './components/glippy-chart/glippy-chart.component';
import { GlippyProductSuggestionComponent } from './components/glippy-product-suggestion/glippy-product-suggestion.component';
import { GlippyTableComponent } from './components/glippy-table/glippy-table.component';

/**
 * Import eagerly next to GungStandardModule and route to AiChatComponent from the app; the module carries
 * no routes of its own. It cannot be lazy-loaded: the product suggestion card uses lib-price,
 * lib-availability and lib-buy-button-wrapper, which only GungStandardModule exports, and that module
 * holds RouterModule.forRoot.
 */
@NgModule({
  declarations: [AiChatComponent, GlippyTableComponent, GlippyChartComponent, GlippyProductSuggestionComponent],
  imports: [CommonModule, FormsModule, TranslateModule, GungCommonModule, GungStandardModule],
  exports: [AiChatComponent, GlippyTableComponent, GlippyChartComponent, GlippyProductSuggestionComponent]
})
export class GlippyChatModule {}
